/**
 * How long a working chat has run ("45h 2m"), ticking every second.
 *
 * @module components/home/RecentThreadWorkingDuration
 */
import { useEffect, useState } from "react";

import { formatWorkingDurationLabel } from "../Sidebar.logic";

export function RecentThreadWorkingDuration({ startedAt }: { readonly startedAt: string | null }) {
  const startedMs = startedAt !== null ? Date.parse(startedAt) : Number.NaN;
  const [, setTick] = useState(0);
  useEffect(() => {
    if (Number.isNaN(startedMs)) return;
    const id = window.setInterval(() => setTick((tick) => tick + 1), 1_000);
    return () => window.clearInterval(id);
  }, [startedMs]);
  if (Number.isNaN(startedMs)) return null;
  return <span className="font-normal tabular-nums">{formatWorkingDurationLabel(Date.now() - startedMs)}</span>;
}
